import { render, staticRenderFns } from "./AlternatingGallery.vue?vue&type=template&id=71b6ad32&scoped=true&"
import script from "./AlternatingGallery.vue?vue&type=script&lang=js&"
export * from "./AlternatingGallery.vue?vue&type=script&lang=js&"
import style0 from "./AlternatingGallery.vue?vue&type=style&index=0&id=71b6ad32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b6ad32",
  null
  
)

export default component.exports